import { baseApi } from '@/config/axios';
import {
  FetchTenantSwitchSettingsParams,
  FetchTenantSwitchSettingsResponse,
} from '@/types/api/tenantApi';

// テナント切り替え設定取得API
export const fetchTenantSwitchSettings = (
  params: FetchTenantSwitchSettingsParams,
): Promise<FetchTenantSwitchSettingsResponse> =>
  baseApi.get('/v1/tenant/switch-targets', { params });
